import React from 'react'
import PropTypes from 'prop-types'

import { useRouter } from 'next/navigation'

import styled from 'styled-components'
import { space, width } from 'styled-system'
import { themeGet } from '@styled-system/theme-get'

const A = styled.a`
  text-decoration: none;
  & :hover {
    text-decoration-color: ${themeGet('colors.font.link')};
  }
  & :visited {
    color: unset;
  }

  ${space};
  ${width};
`

const External = styled(A).attrs({
  target: '_blank',
  rel: 'noreferrer noopener',
})``

function Link({ children, href, ...rest }) {
  const router = useRouter()

  const handleClick = e => {
    e.preventDefault()
    router.push(href)
  }

  return (
    <A href={href} onClick={handleClick} {...rest}>
      {children}
    </A>
  )
}

Link.External = External

Link.propTypes = {
  children: PropTypes.node.isRequired,
  href: PropTypes.string.isRequired,
}

export default Link
